import Vue from 'vue';
import VueRouter from 'vue-router';
import {BasicLayout} from '@/layouts';

Vue.use(VueRouter);

function loadView(view) {
    return () => import('../'+`views${view}.vue`);
}

const routes = [
    {
      path: '/',
      component: BasicLayout,
      children: [
        {
            path: '',
            component: loadView('/Home'),
            meta:{
              title:"广州市提升工程2.0“微能力”大赛"
            }
        },
      ],
      meta:{
        title:"广州市提升工程2.0“微能力”大赛"
      }
    },
    {
        path: '/index',
        component: loadView('/index'),
        meta:{
          title:"广州市提升工程2.0“微能力”大赛"
        }
      },
    {
        path: '/h5',
        component: loadView('/h5'),
        meta:{
          title:"广州市提升工程2.0“微能力”大赛"
        }
      },
    {
        path: '/home',
        name: 'layout',
        component: BasicLayout,
        redirect: '/home',
        children: [
            {
                path: '',
                component: loadView('/Home'),
                meta:{
                  title:"广州市提升工程2.0“微能力”大赛"
                }
            },
            {
                path: '/microTrain',
                component: loadView('/microTrain/microTrain'),
                meta:{
                  title:"广州市提升工程2.0“微能力”大赛"
                }
            },
            {
                path: '/matchResult',
                component: loadView('/matchResult/matchResult'),
                meta:{
                  title:"广州市提升工程2.0“微能力”大赛"
                }
            },
            {
                path: '/liveReview',
                component: loadView('/liveReview/liveReview'),
                meta:{
                  title:"广州市提升工程2.0“微能力”大赛"
                }
            },
            {
                path: '/videoClass',
                component: loadView('/videoClass/videoClass'),
                meta:{
                  title:"广州市提升工程2.0“微能力”大赛"
                }
            },
            {
                path: '/videoDetail',
                component: loadView('/videoClass/videoDetail'),
                meta:{
                  title:"广州市提升工程2.0“微能力”大赛"
                }
            },
        ],
        meta:{
          title:"广州市提升工程2.0“微能力”大赛"
        }
    }, {
        path: '/login',
        name:'login',
        component:loadView('/user/Login'),
        meta:{
          title:"广州市提升工程2.0“微能力”大赛"
        }
    }, {
      path: '/login1',
      name:'login1',
      component:loadView('/user/Login1'),
      meta:{
        title:"广州市提升工程2.0“微能力”大赛"
      }
  }, {
    path: '/art',
    name:'art',
    component:loadView('/user/art'),
    meta:{
      title:"赛事动态"
    }
}
]

const router = new VueRouter({
    mode: 'history',
    base: 'match',
    routes
})

export default router
